import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import AccountHeads from "./Components/AccountHeads/AccountHeads";
import AddAccountHead from "./Components/AccountHeads/AddAccountHead";
import UpdateAccountHead from "./Components/AccountHeads/UpdateAccountHead";
import Accounts from "./Components/Accounts/Accounts";
import AccountReports from "./Components/Accounts/AccountsReport/AccountReports";
import AddAccount from "./Components/Accounts/AddAccount";
import AddAccountExpense from "./Components/Accounts/AddAccountExpense";
import AddAfterSale from "./Components/Accounts/AddAfterSale";
import UpdateAccount from "./Components/Accounts/UpdateAccount";
import Payments from "./Components/Accounts/payments";
import Adjust from "./Components/Adjust/Adjust";
import CreateAdjust from "./Components/Adjust/CreateAdjust";
import Brand from "./Components/Brand/Brand";
import ImportBrand from "./Components/Brand/ImportBrand";
import UpdateBrand from "./Components/Brand/UpdateBrand";
import ImportCategories from "./Components/Category/importCategories";
import ImportCustomer from "./Components/Customer/ImportCustomer.jsx";
import ImportSupplier from "./Components/Supplier/ImportSupplier.jsx";
import { ToastContainer } from "react-bootstrap";
import AddCategory from "./Components/Category/AddCategory";
import Categories from "./Components/Category/Categories";
import UpdateCategory from "./Components/Category/UpdateCategory";
import PrintReceiptById from "./Components/Common/PrintReceipt/PrintReceiptById";
import Profile from "./Components/Common/Profile/Profile";
import Customer from "./Components/Customer/Customer";
import CustomerGroup from "./Components/Customer/CustomerGroup";
import CustomerLedger from "./Components/Customer/CustomerLedger";
import UpdateCustomer from "./Components/Customer/UpdateCustomer";
import Damage from "./Components/Damage/Damage";
import DamageCreate from "./Components/Damage/DamageCreate";
import DamageDetails from "./Components/Damage/DamageDetails";
import DamageSummary from "./Components/Damage/DamageSummary";
import Ecom from "./Components/Ecom/Pages/Ecom/Ecom";
import EcomSaleDeliver from "./Components/Ecom/Pages/EcomUpdate/EcomSaleDeliver";
import EcomSaleProcess from "./Components/Ecom/Pages/EcomUpdate/EcomSaleProcess";
import EcomSaleUpdate from "./Components/Ecom/Pages/EcomUpdate/EcomSaleUpdate";
import Exports from "./Components/Exports/Exports";
import GRN from "./Components/GRN/GRN";
import GRNCreate from "./Components/GRN/GRNCreate";
import GRNDetails from "./Components/GRN/GRNDetails";
import GRNSummary from "./Components/GRN/GRNSummary";
import GrnArticleWise from "./Components/GRN/GrnArticleWise";
import Inventory from "./Components/Inventory/Inventory";
import InventoryAdjust from "./Components/Inventory/InventoryAdjust";
import InventoryDetails from "./Components/Inventory/InventoryDetails";
import InventoryImport from "./Components/Inventory/InventoryImport copy";
import InventoryExport from "./Components/Inventory/InventorySession/InventoryExport";
import InventorySession from "./Components/Inventory/InventorySession/InventorySession";
import InventorySummary from "./Components/Inventory/InventorySummary";
import ProductMovement from "./Components/Inventory/movement/ProductMovement";
import Layout from "./Components/Layout/Layout";
import Ledger from "./Components/Ledger/Ledger";
import Dashboard from "./Components/Pages/DashBoard/Dashboard";
import DayBook from "./Components/Pages/DayBook/DayBook";
import Login from "./Components/Pages/Login/Login";
import NotFound from "./Components/Pages/NotFound/NotFound";
import POS from "./Components/Pages/POS/POS";
import POS2 from "./Components/Pages/POS2/POS2";
import POS3 from "./Components/Pages/POS3/POS3";
import ImportPrice from "./Components/Price/ImportPrice";
import AddProduct from "./Components/Product/AddProduct";
import ImportProduct from "./Components/Product/ImportProduct";
import Products from "./Components/Product/Products";
import UpdateProducts from "./Components/Product/UpdateProducts";
import Purchase from "./Components/Purchase/Purchase";
import PurchaseCreate from "./Components/Purchase/PurchaseCreate";
import PurchaseUpdate from "./Components/Purchase/PurchaseUpdate";
import CreateRtv from "./Components/RTV/CreateRtv";
import RTVDetails from "./Components/RTV/RTVDetails";
import RTVSummary from "./Components/RTV/RTVSummary";
import Rtv from "./Components/RTV/Rtv";
import AllCategorySale from "./Components/Sale/AllCategorySale";
import CategorySale from "./Components/Sale/CategorySale";
import DeleteSale from "./Components/Sale/DeleteSale";
import DueSales from "./Components/Sale/DueSales";
import ExportArticleSale from "./Components/Sale/ExportArticleSale";
import Sales from "./Components/Sale/Sales";
import SupplierProductSale from "./Components/Sale/SupplierProductSale";
import Settings from "./Components/Settings/Settings";
import PaymentSettings from "./Components/Settings/PaymentSettings";
import CreateSupplier from "./Components/Supplier/CreateSupplier";
import Supplier from "./Components/Supplier/Supplier";
import SupplierLedger from "./Components/Supplier/SupplierLedger";
import UpdateSupplier from "./Components/Supplier/UpdateSupplier";
import CreateTpn from "./Components/TPN/CreateTpn";
import TPNDetails from "./Components/TPN/TPNDetails";
import TPNSummary from "./Components/TPN/TPNSummary";
import Tpn from "./Components/TPN/Tpn";
import AddUser from "./Components/User/AddUser";
import UpdateUser from "./Components/User/UpdateUser";
import User from "./Components/User/User";
import UserDetails from "./Components/User/UserDetails";
import { signInUser } from "./Components/Utility/Auth";
import RequireAuth from "./Components/Utility/RequireAuth";
import UpdateWarehouse from "./Components/Warehouse/UpdateWarehouse";
import Warehouse from "./Components/Warehouse/Warehouse";
import Group from "./Components/Group/Group";
import ImportGroup from "./Components/Group/ImportGroup";
import SubCategories from "./Components/SubCategory/SubCategories";
import UpdateSubCategory from "./Components/SubCategory/UpdateSubCategory";
import AddSubCategory from "./Components/SubCategory/AddSubCategory";
import Reports from "./Components/Report/Reports";
import CustomerWiseSalesReport from "./Components/Report/SalesReports/CustomerWiseSalesReport";
import StockIn from "./Components/StockIn/StockIn";
import CreateStockIn from "./Components/StockIn/CreateStockIn";
import ImportSubCategories from "./Components/SubCategory/importSubCategories";
import StockLedger from "./Components/Inventory/StockLedger";
import Home from "./Components/Pages/Home/Home";
import BackupRestore from "./Components/Backup/BackupRestore";
import ECommerceStoreSetup from "./Components/ECommerceStoreSetup/ECommerceStoreSetup";
import { Toaster } from 'react-hot-toast';
import ScrollToTop from "./Components/Common/PageTop/ScrollToTop";
// import ORGReports from "./Components/reports/Reports";
function App() {
  const navigate = useNavigate();
  //@ts-ignore
  const user = signInUser();
  // if (user === null) navigate("login");
  // console.log("User", user);
  const ComponentMapping = {
    pos: POS,
    pos2: POS2,
    pos3: POS3,
  };

  //@ts-ignore
  const posScreen = user?.storeSettings?.posScreen;
  //@ts-ignore
  const SelectedComponent = ComponentMapping[posScreen] || POS;
  // console.log("User",posScreen)
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          {/* Common */}
          <Route path="/login" element={<Login />} />

          {/* REQUIRE AUTH */}
          {/* Dashboard */}
          <Route
            element={
              <RequireAuth
                allowRoles={[
                  "POS",
                  "admin",
                  "manager",
                  "supervisor",
                  "accounts",
                  "ecom",
                ]}
              />
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="inventory-session" element={<InventorySession />} />
          </Route>

          {/* DayBook */}
          <Route element={<RequireAuth allowRoles={["admin", "manager"]} />}>
            <Route path="daybook" element={<DayBook />} />
          </Route>

          {/* POS */}
          {/* TODO:: CHANgE CONDTON FOR SELECTED POS SCREEN */}
          <Route element={<RequireAuth allowRoles={["POS", "admin"]} />}>
            <Route path="pos" element={<SelectedComponent />} />
          </Route>

          {/* Print Reciept */}
          <Route
            element={
              <RequireAuth
                allowRoles={[
                  "POS",
                  "admin",
                  "manager",
                  "supervisor",
                  "accounts",
                  "ecom",
                ]}
              />
            }
          >
            <Route path="print" element={<PrintReceiptById />} />
            <Route path="print/:id" element={<PrintReceiptById />} />
            {/* <Route path="profitReports" element={<ORGReports/>} /> */}
            {/* Profile Setting */}
            <Route path="profile" element={<Profile />} />
          </Route>

          {/* Sales */}
          <Route element={<RequireAuth allowRoles={["admin", "manager"]} />}>
            <Route path="sales" element={<Sales />} />
            <Route path="articleSaleExport" element={<ExportArticleSale />} />
            <Route path="categorySaleExport" element={<CategorySale />} />
            <Route path="allCategorySales" element={<AllCategorySale />} />
            <Route path="delete" element={<DeleteSale />} />
            {/* Customers */}
            <Route path="customer" element={<Customer />} />
            <Route
              path="customer/importCustomer"
              element={<ImportCustomer />}
            />
            <Route path="customer/update/:id" element={<UpdateCustomer />} />
            {/* Customers-Ledger */}
            <Route path="customer/ledger/:id" element={<CustomerLedger />} />
            {/* Customers-Gorup */}
            <Route path="customerGroup" element={<CustomerGroup />} />
            {/* Due Bills */}
            <Route path="duesale" element={<DueSales />} />
            {/* Account-Head */}
          </Route>
          {/* Ecom sales */}
          <Route
            element={<RequireAuth allowRoles={["ecom", "admin", "manager"]} />}
          >
            <Route path="ecom" element={<Ecom />} />
            <Route
              path="/ecom/orderinfoprocess/:id"
              element={<EcomSaleProcess />}
            />
            <Route
              path="/ecom/orderinfoupdate/:id"
              element={<EcomSaleUpdate />}
            />

            <Route
              path="/ecom/orderinfodeliver/:id"
              element={<EcomSaleDeliver />}
            />
          </Route>

          {/* Accounts */}
          <Route element={<RequireAuth allowRoles={["admin", "accounts"]} />}>
            <Route path="accountheads" element={<AccountHeads />} />

            <Route path="addAccountHead" element={<AddAccountHead />} />
            <Route
              path="accountheads/update/:id"
              element={<UpdateAccountHead />}
            />
            <Route path="accounts" element={<Accounts />} />
            <Route path="payments" element={<Payments />} />
            <Route path="addAccount" element={<AddAccount />} />
            <Route path="addAccountExpense" element={<AddAccountExpense />} />
            <Route path="addAfterSale" element={<AddAfterSale />} />
            <Route path="account/update/:id" element={<UpdateAccount />} />
            <Route path="ledger" element={<Ledger />} />
            <Route path="acc_reports" element={<AccountReports />} />
          </Route>

          {/* Reports (Modified) */}
          <Route
            element={<RequireAuth allowRoles={["admin", "manager", "accounts"]} />}
          >
            <Route path="reports/:reportKey" element={<Reports />} />
          </Route>

          {/* Products */}
          <Route element={<RequireAuth allowRoles={["admin", "supervisor", "manager"]} />}>
            <Route path="product" element={<Products />} />
            <Route path="price/import" element={<ImportPrice />} />
            <Route path="product/import" element={<ImportProduct />} />
            <Route path="product/add" element={<AddProduct />} />
            <Route path="product/update/:id" element={<UpdateProducts />} />
            {/* Category */}
            <Route path="category" element={<Categories />} />
            <Route
              path="category/importCategory"
              element={<ImportCategories />}
            />
            <Route path="category/addCategory" element={<AddCategory />} />
            <Route path="category/update/:id" element={<UpdateCategory />} />
            {/* SubCategories */}
            <Route path="subcategory" element={<SubCategories />} />
            <Route
              path="subcategory/update/:id"
              element={<UpdateSubCategory />}
            />
            <Route
              path="subcategory/addSubCategory"
              element={<AddSubCategory />}
            />
            <Route
              path="subcategory/importSubCategory"
              element={<ImportSubCategories />}
            />

            {/* Brand */}
            <Route path="brand" element={<Brand />} />
            <Route path="brand/importBrand" element={<ImportBrand />} />
            <Route path="brand/update/:id" element={<UpdateBrand />} />
            {/* Group */}
            <Route path="group" element={<Group />} />
            <Route path="/group/import" element={<ImportGroup />} />
            {/* Unit */}
            {/* <Route path="unit" element={<Unit />} />

          <Route path="unit/update/:id" element={<UpdateUnit />} /> */}
            {/* Purchase */}
            <Route path="purchase" element={<Purchase />} />
            <Route path="purchase-create" element={<PurchaseCreate />} />
            <Route path="purchase-update/:id" element={<PurchaseUpdate />} />
            {/* 
          <Route
          path="update-purchase/:id"
          element={
            <UpdatePurchase />
          }
          /> */}
            {/* GRN */}
            <Route path="grn" element={<GRN />} />
            <Route path="grn-create" element={<GRNCreate />} />
            <Route path="/grn-details" element={<GRNDetails />} />
            <Route path="/grn-summary" element={<GRNSummary />} />
            <Route path="/grn-article" element={<GrnArticleWise />} />
            {/* RTV */}
            <Route path="rtv" element={<Rtv />} />
            <Route path="rtv-create" element={<CreateRtv />} />
            <Route path="/rtv-summary" element={<RTVSummary />} />
            <Route path="/rtv-details" element={<RTVDetails />} />
            {/* TPN */}
            <Route path="tpn" element={<Tpn />} />
            <Route path="tpn-out" element={<CreateTpn />} />
            <Route path="tpn-details" element={<TPNDetails />} />
            <Route path="tpn-summary" element={<TPNSummary />} />
            {/* Damage */}
            <Route path="damage" element={<Damage />} />
            <Route path="damagecreate" element={<DamageCreate />} />
            <Route path="damage-summary" element={<DamageSummary />} />
            <Route path="damage-details" element={<DamageDetails />} />
            {/* stockIn */}
            <Route path="stockIn" element={<StockIn />} />
            <Route path="create-stockIn" element={<CreateStockIn />} />
            {/* Adjust */}
            <Route path="adjust" element={<Adjust />} />
            <Route path="create-adjust" element={<CreateAdjust />} />
            {/* Supplier */}
            <Route path="supplier" element={<Supplier />} />
            <Route
              path="supplier/importSupplier"
              element={<ImportSupplier />}
            />

            <Route path="create-supplier" element={<CreateSupplier />} />
            <Route path="supplier-ledger/:id" element={<SupplierLedger />} />
            <Route path="update-supplier/:id" element={<UpdateSupplier />} />
            {/* supplierSaleExport */}
            <Route
              path="/supplierSaleExport"
              element={<SupplierProductSale />}
            />
          </Route>

          {/* Inventories */}
          <Route element={<RequireAuth allowRoles={["admin", "manager"]} />}>
            <Route path="inventory" element={<Inventory />} />
            <Route path="inventory-details" element={<InventoryDetails />} />
            <Route path="inventory-summary" element={<InventorySummary />} />
            <Route path="stock-ledger" element={<StockLedger />} />
            <Route path="inventory-export" element={<InventoryExport />} />
            <Route path="inventory-import" element={<InventoryImport />} />
            <Route path="inventory-adjust" element={<InventoryAdjust />} />
            {/* COGS */}
            {/* <Route path="cogs" element={<Cogs />} /> */}
            <Route path="product-movement" element={<ProductMovement />} />
            {/* Exports */}
            <Route path="exports" element={<Exports />} />

            {/* Reports */}
            <Route path="reports" element={<Reports />} />
            <Route path="reports/:reportKey" element={<Reports />} />
            <Route
              path="/reports/customerWiseSales"
              element={<CustomerWiseSalesReport />}
            />

            {/* Users */}
            <Route path="user" element={<User />} />
            <Route path="user/add" element={<AddUser />} />
            <Route path="user/:id" element={<UserDetails />} />
            <Route path="user/update/:id" element={<UpdateUser />} />
            {/* SMS */}
            {/* <Route path="sms" element={<SmsPage />} /> */}
            {/* Store Setting */}
            <Route path="settings" element={<Settings />} />
            <Route path="payment-settings" element={<PaymentSettings />} />
            {/* Store Setting */}
            <Route path="eCommerceStoreSetup" element={<ECommerceStoreSetup />} />
          </Route>
          <Route element={<RequireAuth allowRoles={["admin"]} />}>
            {/* Warehouse */}
            <Route path="warehouse" element={<Warehouse />} />
            <Route path="warehouse/update/:id" element={<UpdateWarehouse />} />
            {/* Backup & Restore */}
            <Route path="backup" element={<BackupRestore />} />
          </Route>
          {/* REQUIRE AUTH END */}

          {/* Not Found */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <ToastContainer />
      <Toaster position="bottom-right" />
    </>
  );
}

export default App;
